import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function Berkarir() {
    const navigate = useNavigate();
    // Define state
    const [career, setCareer] = useState([]);

    // Function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/career/readCareer`);
            const data = await response.data;

            setCareer(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        // Call method "fetchData"
        fetchData();
    }, []);

    const handleDelete = async (id_berkarir) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Make axios delete request
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/career/deleteCareer/${id_berkarir}`
                    );
                    // Refetch data after successful delete
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Cover Foto",
            selector: (row) => (
                <img
                    src={
                        row.cover.startsWith("http")
                            ? row.cover
                            : `${process.env.REACT_APP_API_URL}/career/uploads/${row.cover}`
                    }
                    alt="cover"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Judul",
            selector: (row) => row.judul,
            sortable: true,
            width: "450px",
        },
        {
            name: "Penjelasan",
            selector: (row) => row.penjelasan,
            sortable: true,
            width: "450px",
        },
        {
            name: "Foto 1",
            selector: (row) =>
                row.foto_1 && (
                    <img
                        src={
                            row.foto_1.startsWith("http")
                                ? row.foto_1
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_1}`
                        }
                        alt="foto 1"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Foto 2",
            selector: (row) =>
                row.foto_2 && (
                    <img
                        src={
                            row.foto_2.startsWith("http")
                                ? row.foto_2
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_2}`
                        }
                        alt="foto 2"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Foto 3",
            selector: (row) =>
                row.foto_3 && (
                    <img
                        src={
                            row.foto_3.startsWith("http")
                                ? row.foto_3
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_3}`
                        }
                        alt="foto 3"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Foto 4",
            selector: (row) =>
                row.foto_4 && (
                    <img
                        src={
                            row.foto_4.startsWith("http")
                                ? row.foto_4
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_4}`
                        }
                        alt="foto 4"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Foto 5",
            selector: (row) =>
                row.foto_5 && (
                    <img
                        src={
                            row.foto_5.startsWith("http")
                                ? row.foto_5
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_5}`
                        }
                        alt="foto 5"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Foto 6",
            selector: (row) =>
                row.foto_6 && (
                    <img
                        src={
                            row.foto_6.startsWith("http")
                                ? row.foto_6
                                : `${process.env.REACT_APP_API_URL}/career/uploads/${row.foto_6}`
                        }
                        alt="foto 6"
                        style={{ width: "100px", height: "70px" }}
                    />
                ),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={"/careerEdit/" + row.id_berkarir} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button
                        onClick={() => handleDelete(row.id_berkarir)}
                        className="btn btn-danger"
                    >
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
            width: "150px",
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Berkarir YKBUT</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Info Berkarir YKBUT</h3>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        {career.length === 0 && (
                                            <Link to="/careerAdd" className="btn btn-primary">
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Add Data
                                            </Link>
                                        )}
                                        <DataTable columns={columns} data={career} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Berkarir;
